export const meta = {
  slug: { de: "telefon-besetzt-anrufe-im-praxisalltag", en: "phone-busy-calls-in-daily-practice" },
  title: "Wenn das Telefon ständig klingelt: Erreichbarkeit ohne Unterbrechung",
  excerpt:
    "Ständige Anrufe unterbrechen Behandlungen und binden Aufmerksamkeit. Eine ruhige Erreichbarkeit beginnt damit, das Telefon nicht als einzigen Weg zu denken.",
  category: "praxen",
  publishedAt: "2026-04-21",
  metaTitle: "Telefon Erreichbarkeit in Praxen | OnePractix",
  metaDescription:
    "Wie Praxen Anrufe ruhig strukturieren, ohne den Praxisalltag zu unterbrechen – Einblicke zu Erreichbarkeit, Patientenwegen und Terminorganisation.",
  related: ["online-terminbuchung-wann-sinnvoll", "praxiswebsite-was-patienten-wirklich-suchen"],
  en: {
    title: "When the phone keeps ringing: availability without interruption",
    metaTitle: "Phone availability in medical practices | OnePractix",
    metaDescription:
      "How practices structure calls calmly without interrupting daily work — insights on availability, patient flow and appointments.",
    excerpt:
      "Constant calls interrupt treatments and bind attention. Calm availability begins by no longer treating the phone as the only path.",
  },
};

export default meta;
